export default "__VITE_ASSET__oLIrHg5P__"